import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.captureUTMParams()
  }

  captureUTMParams() {
    const urlParams = new URLSearchParams(window.location.search)
    const utmParams = ['utm_source', 'utm_medium', 'utm_campaign']

    utmParams.forEach(param => {
      const value = urlParams.get(param)
      if (value) {
        sessionStorage.setItem(param, value)
        this.setCookie(param, value, 30)
      }
    })
  }

  setCookie(name, value, days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    const expires = `expires=${date.toUTCString()}`
    document.cookie = `${name}=${value};${expires};path=/`
  }
}
